import React from 'react';
import { Users, ShoppingCart, Sparkles } from 'lucide-react';
import { servicesContent } from '@/hooks/useContent';

// Icon mapping
const iconMap = {
  ShoppingCart: ShoppingCart,
  Users: Users,
  Sparkles: Sparkles,
};

const Services = () => {
  const content = servicesContent;

  return (
    <section 
      id="services" 
      className="py-24"
      style={{ backgroundColor: content.background?.color || '#FFFFFF' }}
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="section-title text-4xl md:text-5xl font-bold mb-4" data-testid="services-title">
            {content.title}
          </h2>
          <p className="section-subtitle text-xl max-w-2xl mx-auto" data-testid="services-subtitle">
            {content.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {content.services?.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Sparkles;
            return (
              <div 
                key={index}
                className="service-card group"
                data-testid={`service-card-${index}`}
              >
                <div className="service-card-image-container relative h-64 overflow-hidden rounded-t-lg">
                  <img 
                    src={service.image}
                    alt={service.image_alt || service.title}
                    className="service-card-image w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>
                <div className="service-card-content p-8">
                  <div className="service-icon mb-4">
                    <IconComponent size={40} />
                  </div>
                  <h3 className="text-2xl font-bold mb-3">
                    {service.title}
                  </h3>
                  <p className="service-description text-base leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
